import { Icon, AccountOpeningTermsDrawer } from "@ui-kit/components/index.es";
import { Field, Form, withFormik } from "formik";
import moment from "moment";
import { bool, func, shape } from "prop-types";
import React, { Component } from "react";
import classNames from "classnames";
import Col from "react-bootstrap/lib/Col";
import { connect } from "react-redux";
import { compose } from "redux";
import Yup from "yup";

import Button from "pages/_components/Button";
import Checkbox from "pages/_components/Checkbox";
import Container from "pages/_components/Container";
import Credential from "pages/_components/fields/credentials/Credential";
import I18n from "pages/_components/I18n";

import { actions as accountsActions, selectors as accountsSelectors } from "reducers/accounts";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as sessionSelectors } from "reducers/session";

import * as configUtils from "util/config";
import * as i18n from "util/i18n";
import isTokenActive from "util/token";

import { isIOS } from "react-device-detect";
import {
    resolveAccountOpeningTyCAccountTypeLabel,
    resolveAccountOpeningTyCCurrencyLabel,
    resolveAccountOpeningTyCTermsDocumentKey,
} from "util/accountOpeningTyC";
import { CURRENCY_CODE } from "../../constants";

const FORM_ID = "accounts.new.account";

const URL_CMF = "https://bancocmf.com.ar/tarifario/";

class AccountTokenConfirmation extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        isSubmitting: bool.isRequired,
        isDesktop: bool.isRequired,
        values: shape({}).isRequired,
        openingData: shape({}).isRequired,
        fetchingDownload: bool.isRequired,
        isRetailEnvironment: bool.isRequired,
    };

    state = {
        showDrawer: false,
    };

    handleDismiss = () => {
        this.setState((prev) => ({ showDrawer: !prev.showDrawer }));
    };

    navigateToCMF = () => {
        if (!window.cordova) {
            window.open(URL_CMF, "_blank", "noopener noreferrer");
        } else if (!isIOS) {
            window.navigator.app.loadUrl(URL_CMF, { openExternal: true });
        } else if (window.cordova) {
            window.cordova.InAppBrowser.open(
                URL_CMF,
                "_system",
                "hidden=no,location=no,clearsessioncache=yes,clearcache=yes",
            );
        }
    };

    render() {
        const {
            dispatch,
            isSubmitting,
            isDesktop,
            values,
            openingData,
            fetchingDownload,
            isRetailEnvironment,
        } = this.props;
        const { showDrawer } = this.state;
        const enableTyC =
            (openingData?.accountType === 3 && `${openingData?.currency}` === CURRENCY_CODE.USD) ||
            configUtils.getBoolean("frontend.request.checkingAccount.Currency.functionalities", false);

        const termsDocumentKey = resolveAccountOpeningTyCTermsDocumentKey(
            openingData?.accountType,
            isRetailEnvironment,
        );
        const termsDrawerTitle = i18n.get("accounts.new.termsAndConditions.title", null, {
            tipoCuenta: resolveAccountOpeningTyCAccountTypeLabel(openingData?.accountType),
            moneda: resolveAccountOpeningTyCCurrencyLabel(openingData?.currency),
        });

        return (
            <>
                <Form className={!isDesktop ? "above-the-fold" : "confirmation__container"}>
                    <Container
                        className={classNames({
                            "flex-grow align-items-center container-white pb-4": !isDesktop,
                        })}
                        gridClassName={isDesktop && "confirmation__form confirmation__box"}>
                        <Col className="col-12 col-xl-12" lg={12} md={9} sm={12}>
                            <div className="admin-content-center">
                                {!isTokenActive(!isDesktop) ? (
                                    <I18n id="transfer.summary.confirm.label" />
                                ) : (
                                    <I18n
                                        id="confirmation.withoutotp.text"
                                        component="p"
                                        componentProps={{ className: "confirmation__text-without-otp" }}
                                    />
                                )}
                            </div>
                            <div className="account__solicitude-pass">
                                <Field
                                    name="otp"
                                    type="otp"
                                    idForm={FORM_ID}
                                    component={Credential}
                                    loading={isSubmitting}
                                    placeholderText={i18n.get("confirmation.otp.placeholder")}
                                />
                            </div>
                            {enableTyC && (
                                <>
                                    <div className="account__solicitude-pass pt-45 pb-25">
                                        <Field
                                            idForm={FORM_ID}
                                            name="acceptTerms"
                                            component={Checkbox}
                                            className="mb-0"
                                            linkLabel={`${FORM_ID}.termsAndConditions.label`}
                                            onClickLabel={() => this.handleDismiss()}
                                            linkColor="primary"
                                        />
                                    </div>
                                    <div className="account__solicitude-pass">
                                        <div
                                            aria-haspopup="dialog"
                                            tabIndex={0}
                                            onClick={this.navigateToCMF}
                                            onKeyDown={(e) => {
                                                if (e.key === "Enter") {
                                                    this.navigateToCMF();
                                                }
                                            }}
                                            className="btn btn-link btn-small btn-scheduler mh-auto m-0 p-0 gap-05"
                                            role="button">
                                            <Icon name="SendDown" size={16} variant="outline" color="primary-color" />
                                            <div
                                                className="c-control-text"
                                                style={{
                                                    textTransform: "none",
                                                    color: "#072229",
                                                    fontFamily: "Graphik-Regular",
                                                }}>
                                                <I18n
                                                    id={`${FORM_ID}.downloadFares.label`}
                                                    componentProps={{ "aria-hidden": true }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </Col>
                        <Container className="flex-grow align-items-center w-100" gridClassName="form-content">
                            <Col lg={12} md={12} sm={12}>
                                <Col className="confirmation__content-button" lg={12} md={12} sm={12}>
                                    <div className="admin-content-center">
                                        <Button
                                            type="submit"
                                            bsStyle="primary"
                                            label="global.confirm"
                                            loading={isSubmitting}
                                            image="images/arrowRight.svg"
                                            imageStyle="mr-2"
                                            disabled={enableTyC && !values.acceptTerms}
                                        />
                                    </div>
                                </Col>
                            </Col>
                        </Container>
                    </Container>
                </Form>
                {enableTyC && (
                    <AccountOpeningTermsDrawer
                        isVisible={showDrawer}
                        onClose={this.handleDismiss}
                        title={termsDrawerTitle}
                        downloadLabel={i18n.get("global.download")}
                        downloadAriaLabel={i18n.get("global.download")}
                        isDownloadLoading={fetchingDownload}
                        onDownload={() => dispatch(loginActions.downloadDocumentI18n("pdf", termsDocumentKey))}>
                        <I18n component="p" id={termsDocumentKey} />
                    </AccountOpeningTermsDrawer>
                )}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    openingData: accountsSelectors.getAccountOpeningData(state),
    userId: sessionSelectors.getUser(state).userId,
    fullName: sessionSelectors.getUser(state).userFullName,
    isRetailEnvironment: sessionSelectors.isRetailEnvironment(state),
    fetchingDownload: loginSelectors.getFetchingDownload(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        mapPropsToValues: () => ({ otp: "" }),
        validationSchema: (props) => {
            const enableTyC =
                (props.openingData?.accountType === 3 && `${props.openingData?.currency}` === CURRENCY_CODE.USD) ||
                configUtils.getBoolean("frontend.request.checkingAccount.Currency.functionalities", false);
            return Yup.object().shape({
                otp: Yup.string().required(i18n.get("accounts.new.account.otp.error.required")),
                acceptTerms: enableTyC
                    ? Yup.bool()
                          .required(i18n.get("enrollment.index.invitationCode.empty"))
                          .oneOf([true], i18n.get("enrollment.index.acceptTerms.required"))
                    : Yup.bool().nullable(),
            });
        },
        handleSubmit: ({ otp, acceptTerms }, formikBag) => {
            const { dispatch, openingData, userId, fullName } = formikBag.props;
            const enableTyC =
                (openingData?.accountType === 3 && `${openingData?.currency}` === CURRENCY_CODE.USD) ||
                configUtils.getBoolean("frontend.request.checkingAccount.Currency.functionalities", false);
            let fechaHoraTyC = "";
            let userName = "";
            let termsAndConditions = "";
            if (enableTyC) {
                fechaHoraTyC = moment(Date())
                    .format("DD/MM/YYYY HH:mm:ss")
                    .toString();
                userName = fullName;
                termsAndConditions = acceptTerms ? "Aceptado" : "";
                dispatch(
                    accountsActions.openingAccount(
                        {
                            ...openingData,
                            idActivity: "accounts.opening",
                            acceptTerms,
                            userName,
                            fechaHoraTyC,
                            termsAndConditions,
                        },
                        otp,
                        userId,
                        formikBag,
                    ),
                );
            } else {
                dispatch(
                    accountsActions.openingAccount(
                        { ...openingData, idActivity: "accounts.opening", acceptTerms },
                        otp,
                        userId,
                        formikBag,
                    ),
                );
            }
        },
    }),
)(AccountTokenConfirmation);
